import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { PlanChangePreflightResponseDto } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Phase 0 plan-change preflight check. Returns blocked: false with an empty
 * violations array when the requested plan change is allowed; otherwise
 * blocked: true with one or more structured violations
 * (plan_change_blocked_members | plan_change_blocked_workspace_type |
 * plan_change_blocked_guests in Phase 0; Phase 3 will extend with Free-cap
 * and second-Free-workspace codes on the same payload).
 *
 * UI calls this BEFORE opening checkout / change-plan so PlanChangeBlockedModal
 * can render without a 400 round-trip.
 */
export async function planChangePreflight(
  targetPlanCode: string,
): Promise<PlanChangePreflightResponseDto> {
  const response = await AuthAxios.get<PlanChangePreflightResponseDto>(
    `${ENDPOINT_SUBSCRIPTIONS}/plan-change-preflight`,
    { params: { targetPlanCode } },
  )
  return response.data
}
